module.exports = "/_next/static/images/e748069adc1478dd5bf38fcf844c3b1c-group-man-building@0.5x.jpg";